// extracted by mini-css-extract-plugin
export var promotionLink = "_ve-0";